import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import moment from "moment";
// import CommentBox from "../common/ComentBox";
import Members from "./Members";
import { useNavigate } from "react-router-dom";
import Leaderboard from "./Leaderboard";
import { getClubLeaderboard } from "../../../api/getClubLeaderboard";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import shareSVG from "../../../assets/customerAssets/icons/share.svg";

const Index = ({ club, setClub }) => {
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState(null);

  const fetchClubLeaderBoard = useCallback(async (id, token, data) => {
    try {
      const goalsData = await getClubLeaderboard(id, token, data);
      if (goalsData?.data?.rows?.length > 0) {
        setGoals(goalsData.data.rows);
      } else {
        setGoals([]);
        toast.error(`No videos found!`);
      }
    } catch (e) {
      setGoals([]);
    }
  }, []);

  useEffect(() => {
    if (club.id && token) {
      fetchClubLeaderBoard(club.id, token, {
        month: null,
        year: new Date().getFullYear(),
      });
    }
  }, [club]);

  const navigate = useNavigate();
  return (
    <Box className="view_feature_wrapper view_club_wrapper">
      <Box className="header club_header">
        <IconButton
          onClick={() => {
            navigate("/myaccount");
            // navigate(-1);
          }}
        >
          <ArrowBackIcon sx={{ color: "white" }} />
        </IconButton>

        <Box className="text_div club_text_div">
          <Typography component={"span"} className="title club_title">
            {club?.title}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ borderBottom: "1px solid #414466" }}></Box>
      <Box className="content club_content">
        <Box className="content_a club_content_a">
          <Box className="img_wrapper club_img_wrapper">
            <img src={club?.club_logo} />
          </Box>

          <Box className={"share-div"}>
            <Button
              onClick={async () => {
                if (club.shareLink) {
                  await navigator.clipboard.writeText(club.shareLink);
                  toast.success("Share link copied!");
                } else {
                  toast.error("No share link found!");
                }
              }}
            >
              <img src={shareSVG} height={20} width={20} alt="share"></img>{" "}
              Share
            </Button>
          </Box>
        </Box>

        <Box className="content_b club_content_b">
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Description: </strong>
            {club?.description}
          </Typography>

          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Video From (UK/International): </strong>
            {club?.from_uk ? "England" : "International"}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Created By: </strong>
            {club?.club_owner?.firstName + " " + club?.club_owner?.lastName}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Created On: </strong>
            {moment(club?.createdAt).format("MM/DD/YYYY")}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>City/Town: </strong>
            {club?.region}
          </Typography>

          <Box className="content_b_a club_content_b_a">
            <Button className="category_button club_category_button">
              {club?.clubCat?.name}
            </Button>
            {club?.clubSubCat ? (
              <Button className="category_button club_category_button">
                {club?.clubSubCat?.name}
              </Button>
            ) : null}
            <Button className="category_button club_category_button">
              {club?.visibility ? "Public" : "Private"}
            </Button>
          </Box>
        </Box>

        <Members members={club?.clubMembers} />

        <Leaderboard
          setTournamentData={setClub}
          goals={goals}
          club_logo={club.club_logo}
          fetchLeaderboard={fetchClubLeaderBoard}
          clubData={club}
        />
      </Box>
    </Box>
  );
};

export default Index;
